// extracted by mini-css-extract-plugin
module.exports = {"blockInstructionCards":"instruction-cards_blockInstructionCards__3UZe9","cards":"instruction-cards_cards__EDdFe","cardImg":"instruction-cards_cardImg__1rL8d"};